import { Add, TableRows, ViewModule, Visibility } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";

import SearchContainer from "components/SearchContainer";
import Table, { ColumnType } from "components/Table";
import { useContext, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { ResType } from "types";
import { UserProfileContext } from "context/UserProfile";
import useTitle from "hooks/useTitle";
import _ from "lodash";
import sortHandler from "components/Table/SortHandler";
import { SortDirection } from "data/constants";
import { usePermissions } from "context/PermissionsProvider";
import { Permissions } from "data/permissons";

import AddMcaCredentials from "./addMcaCredentials";
import { getMcaClients } from "api/services/mca/mca-client";
import ClientCardView from "./ClientCardView";

const McaClients = () => {
  useTitle("ATOM Pro | MCA Clients");

  const { permissions } = usePermissions();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState<any>({});
  const [selected, setSelected] = useState<any[]>([]);
  const [viewMode, setViewMode] = useState<"table" | "card">("table");


  // const getCategoryLabel = (value?: string) => {
  //   return (
  //     CLIENT_CATEGORIES.find((cat) => cat.value === value)?.label || "--"
  //   );
  // };

  // const getSubCategoryLabel = (
  //   categoryValue?: string,
  //   subCategoryValue?: string
  // ) => {
  //   const category = CLIENT_CATEGORIES.find(
  //     (cat) => cat.value === categoryValue
  //   );

  //   return (
  //     category?.subCategories?.find(
  //       (sub) => sub.value === subCategoryValue
  //     )?.label || "--"
  //   );
  // };


  const { data, isLoading }: ResType = useQuery(
    [
      "get-mca-client",
      { limit: pageCount, offset: page * pageCount, search, sort },
    ],
    getMcaClients,
    {
      enabled:
        permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
        permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS),
    }
  );

  const totalCount = data?.data?.count;

  let defaultColumns: Array<ColumnType> = [
    {
      key: "clientId",
      title: "Client ID",
      sort: true,
      direction: SortDirection.ASC,
      render: (v) => (
        <Typography>
          {v?.client?.clientId || "--"}
        </Typography>
      ),
    },
    {
      key: "category",
      title: "Category",
      sort: true,
      direction: SortDirection.ASC,
      render: (v) => (
        <Typography>
          {/* {getCategoryLabel(v?.client?.category)} */}
        </Typography>
      ),
    },
    {
      key: "subCategory",
      title: "Sub Category",
      sort: true,
      direction: SortDirection.ASC,
      render: (v) => (
        <Typography>
          {/* {getSubCategoryLabel(
            v?.client?.category,
            v?.client?.subCategory
          )} */}
        </Typography>
      ),
    },
    {
      key: "displayName",
      title: "Client Name",
      sort: true,
      direction: SortDirection.ASC,
      render: (v) => (
        <Typography>
          {v?.client?.displayName || "--"}
        </Typography>
      ),
    },
    {
      key: "cin",
      title: "CIN",
      sort: true,
      direction: SortDirection.ASC,
      render: (v) => (
        <Typography>
          {v?.client?.cin || "--"}
        </Typography>
      ),
    },
    // {
    //   key: "panNumber",
    //   title: "PAN",
    //   sort: true,
    //   render: (v) => (
    //     <Typography>
    //       {v?.client?.panNumber || "--"}
    //     </Typography>
    //   ),
    // },
    {
      key: "id",
      title: "Actions",
      render: (rowData: any) => <Actions data={rowData} />,
    },
  ];

  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));

  const handleSort = (v: any) => {
    sortHandler({
      key: v.key,
      columns,
      sortState: sort,
      setSortState: setSort,
      setColumns: setColumns,
    });
  };

  const Actions = ({ data }: any) => {
    const handleView = () => {
      navigate(`/atom-pro/mca/${data?.id}`);
    };

    return (
      <Box display="flex" gap={1}>
        <Tooltip title="View">
          <IconButton onClick={handleView} size="small">
            <Visibility />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };

  return (
    <Box m={1}>
      <Box display="flex" justifyContent="flex-end">
        <SearchContainer
          debounced
          value={search}
          placeHolder="Search by Client Name"
          onChange={setSearch}
        />

        <Button
          variant="outlined"
          startIcon={<Add />}
          sx={{ ml: 2 }}
          color="secondary"
          onClick={() => setOpen(true)}
        >
          Add MCA
        </Button>
        <ToggleButtonGroup
          value={viewMode}
          exclusive
          size="small"
          onChange={(_, value) => value && setViewMode(value)}
        >
          <ToggleButton value="table">
            <TableRows fontSize="small" />
          </ToggleButton>
          <ToggleButton value="card">
            <ViewModule fontSize="small" />
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Box m={1} mb={5}>
        {viewMode === "table" ? (
          <Table
            sx={{ height: "525px" }}
            pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
            data={data?.data?.result || []}
            columns={columns}
            sortHandler={handleSort}
            loading={isLoading}
            selection={{ selected, setSelected }}
          />
        ) : (
          <ClientCardView
            data={data?.data?.result || []}
            loading={isLoading}
          />
        )}
      </Box>


      <AddMcaCredentials open={open} setOpen={setOpen} />
    </Box>
  );
};

export default McaClients;
